{
  "name": "@uppy/golden-retriever",
  "description": "The GoldenRetriever Uppy plugin saves selected files in browser cache to seamlessly resume uploding after browser crash or accidentally closed tab",
  "version": "4.2.2",
  "license": "MIT",
  "main": "lib/index.js",
  "type": "module",
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "typecheck": "tsc --build"
  },
  "keywords": [
    "file uploader",
    "restore files",
    "crash recovery",
    "golden retriever",
    "resumable uploads",
    "uppy",
    "uppy-plugin"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "dependencies": {
    "@uppy/utils": "workspace:^",
    "lodash": "^4.17.21"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "devDependencies": {
    "typescript": "^5.8.3"
  }
}
